module.exports = __webpack_public_path__ + "static/media/SoundCloud.7c335881.svg";